import {z} from 'zod'
import {timezones} from './timezones.js'

export const Timezone = z.string().check(
  z.refine((timezone) => timezones.includes(timezone)),
  z.refine((timezone) => ({message: `Timezone ${timezone} not supported`})),
)
export type Timezone = z.infer<typeof Timezone>
